import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { colors } from '@joykit';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  });

  const getBorderColor = (error: boolean, focused: boolean, after: boolean) => {
    if (error) {
      return colors.bad;
    } else if (focused) {
      return '#322E53';
    }
    return after ? 'transparent' : '#DBDBDB';
  };

  export const inputContainer = (error: boolean = false, focused: boolean = false) => {
    const animation = animationTransition('border-color', 'opacity');
    const afterBorderColor = getBorderColor(error, focused, true);
    const borderColor = getBorderColor(error, focused, false);
    const opacity = focused ? 1 : 0;

    return css({
      ...getInterUIDynamicMetricCssObject(10),
      fontWeight: 700,
      display: 'flex',
      color: '#fff',
      backgroundColor: '#fff',
      borderRadius: 5,
      position: 'relative',
      padding: 0,
      width: '100%',
      alignItems: 'center',
      height: 48,
      border: `1px solid ${borderColor}`,
      '&::after': {
        content: '" "',
        display: 'block',
        position: 'absolute',
        opacity: opacity,
        top: '-1px',
        left: '-1px',
        right: '-1px',
        bottom: '-1px',
        border: `3px solid ${afterBorderColor}`,
        borderRadius: '5px',
        pointerEvents: 'none',
        transition: `${animation}`
      }
    });
  };

  export const iconWrapper = css({
    backgroundColor: '#EAEAEA',
    borderRadius: '5px 0 0 5px',
    flex: '0 0 48px',
    padding: '16 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  });

  export const inputWrapper = css({
    flex: '1 0 auto',
    height: '100%'
  });

  export const input = css({
    height: '100%',
    textIndent: 8,
    width: '100%',
    border: 'none',
    fontSize: 15,
    color: '#000',
    fontFamily: 'Inter UI',
    borderRadius: '0 5px 5px 0',
    ':focus': {
      outline: 'none'
    },
    '::placeholder': {
      fontSize: 15,
      color: '#BBBBBB',
      fontFamily: 'Inter UI'
    }
  });

  export const visiblyHidden = css({
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1
  });

  export const errorText = css({
    ...getInterUIDynamicMetricCssObject(10),
    color: colors.bad,
    marginLeft: 8,
    marginTop: 8
  });
}
